import { defineRecipe } from '@chakra-ui/react';

import {
  textAreaBorderRadius,
  textAreaColors,
  textAreaPaddingBottom,
  textAreaPaddingTop,
  textAreaPaddingX,
} from './text-area.kds';

/** KDS Text Area overrides — Figma node 1078:11889. Register as `textarea` in `theme/system.ts`. */
export const textAreaRecipe = defineRecipe({
  className: 'chakra-textarea',
  base: {
    width: 'full',
    minWidth: '0',
    outline: '0',
    appearance: 'none',
    textAlign: 'start',
    textStyle: 'default.regular',
    borderRadius: textAreaBorderRadius,
    bg: textAreaColors.background,
    color: textAreaColors.text,
    borderWidth: '1px',
    borderColor: textAreaColors.border.default,
    px: textAreaPaddingX,
    pt: textAreaPaddingTop,
    pb: textAreaPaddingBottom,
    _placeholder: {
      color: textAreaColors.placeholder,
    },
    _hover: {
      borderColor: textAreaColors.border.hover,
    },
    _focus: {
      borderColor: textAreaColors.border.active,
      outline: 'none',
    },
    _disabled: {
      bg: textAreaColors.disabledBackground,
      borderColor: textAreaColors.border.disabled,
      opacity: 1,
      cursor: 'not-allowed',
      _placeholder: {
        color: textAreaColors.placeholder,
      },
    },
    _invalid: {
      borderColor: textAreaColors.border.error,
      _focus: {
        borderColor: textAreaColors.border.error,
      },
    },
  },
  variants: {
    variant: {
      outline: {
        focusVisibleRing: 'none',
      },
    },
  },
  defaultVariants: {
    variant: 'outline',
  },
});
